import { render, staticRenderFns } from "./ViewTask.html?vue&type=template&id=19df916c&scoped=true&"
import script from "./ViewTask.vue?vue&type=script&lang=js&"
export * from "./ViewTask.vue?vue&type=script&lang=js&"
import style0 from "./ViewTask.vue?vue&type=style&index=0&id=19df916c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df916c",
  null
  
)

export default component.exports